import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';

const WhyUsSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="why-us">
      <div className="why-header rev">
        <div className="section-tag">{t.whyUs.tag}</div>
        <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>
          {t.whyUs.title.split('\n').map((line, i) => (
            <span key={i}>{i === 0 ? <>{line}<br /></> : <em>{line}</em>}</span>
          ))}
        </h2>
        <p className="section-sub">{t.whyUs.subtitle}</p>
      </div>

      <div className="why-grid">
        {t.whyUs.tiers.map((tier, i) => (
          <div className={`why-card rev del-${i + 1}`} key={i}>
            <div className="why-label">{tier.label}</div>
            <div className="why-examples">{tier.examples}</div>

            <div className="why-table">
              <div className="why-table-header">
                <span />
                <span className="why-col-us">ADD.IS</span>
                <span className="why-col-them">Others</span>
              </div>
              {tier.items.map((item, j) => (
                <div className="why-row" key={j}>
                  <span className="why-text">{item.text}</span>
                  <span className={`why-check ${item.us ? 'yes' : 'no'}`}>
                    {item.us ? '✓' : '✗'}
                  </span>
                  <span className={`why-check ${item.them ? 'yes' : 'no'}`}>
                    {item.them ? '✓' : '✗'}
                  </span>
                </div>
              ))}
            </div>

            <div className="why-advantage">{tier.advantage}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUsSection;
